import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, } from '@servicetitan/design-system';
import classNames from 'classnames';
import * as Styles from './select-cell.module.css';
import { useTdProps } from '../utils/use-td-props';
export const SelectCell = ({ selectionChange, control: Control = Checkbox, ...props }) => {
    const onChange = (_0, _1, event) => {
        if (!selectionChange) {
            return;
        }
        selectionChange({ syntheticEvent: event });
    };
    return _jsx(Control, { className: Styles.checkbox, onChange: onChange, ...props });
};
const stopPropagation = (e) => e.stopPropagation();
export const SelectColumnCell = (props) => {
    const tdProps = useTdProps(props);
    if (props.rowType === 'groupHeader') {
        return null;
    }
    if (props.rowType === 'groupFooter') {
        return _jsx("td", { ...tdProps });
    }
    return (_jsx("td", { style: props.style, 
        // prevent onRowClick when user misses row selection
        onClick: stopPropagation, className: classNames(props.className, 'cursor-default-i'), ...tdProps, children: _jsx(SelectCell, { checked: props.dataItem.selected, disabled: !props.isRowSelectable, selectionChange: props.selectionChange, indeterminate: props.dataItem.indeterminate, control: props.control }) }));
};
export const SelectHeaderCell = (props) => (_jsx(SelectCell, { checked: props.selectionValue, indeterminate: props.isSomeRowsSelected, selectionChange: props.selectionChange, control: props.control }));
//# sourceMappingURL=select-cell.js.map